import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';
import { ticketingDashboardKeys } from './ticketing/keys';
import { eventTicketKeys, seasonTicketKeys } from './tickets/keys';

const eventsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'events'] as const;
  return createQueryKey({
    all: [...key] as const,
    // Event dates represents the event dates at an org level, not event dates at an event level which is what the id.dates key represents.
    ticketingDashboard: ticketingDashboardKeys([...key] as const),
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
        tickets: eventTicketKeys([...key, itemId]),
        seasonPasses: seasonTicketKeys([...key, itemId]),
        dates: createQueryKey({
          all: [...key, itemId, 'dates'] as const,
          id: <U extends QueryKeyParam>(id: U) =>
            createQueryKey({
              all: [...key, itemId, 'dates', id] as const,
              detail: [...key, itemId, 'dates', id, 'detail'] as const,
              inventories: [...key, itemId, 'dates', id, 'inventories'] as const,
              inventorySummary: [...key, itemId, 'dates', id, 'inventorySummary'] as const,
            }),
          allInventories: [...key, itemId, 'dates', 'inventories'] as const,
          export: [...key, itemId, 'dates', 'export'] as const,
        }),
      }),
  });
};

export { eventsKeys };
